/**
 * Registration View
 */

define(function(require) {
    var _ = require('underscore');
    var $ = require('j');
    var core = require('core');
    var PortletView = require('modules/portlet/portlet.view');
    var user = require('user');
    var history = require('util/history.util');
    var device = require('util/device.util');
    var errorMessageMixin = require('portlets/registration/mixins/error.message.mixin');
    var userNameMixin = require('portlets/registration/mixins/username.mixin');
    var promocodeMixin = require('portlets/registration/mixins/promocode.mixin');
    var formRulesUtil = require('portlets/registration/util/formRulesUtil');
    var Form = require('class/form.class');
    var notifier = require('managers/notification.manager.instance');
    var scrollManager = require('managers/scroll.manager');
    var serverUtil = require('util/server.util');
    var recaptchaMixin = require('modules/google-recaptcha/mixin');
    var config = require('config');
    var i18n = require('i18n');
    const tooltipsMixin = require('portlets/registration/mixins/tooltips.mixin');

    return PortletView.extend({

        isLoading: false,

        mixins: [errorMessageMixin, userNameMixin, promocodeMixin, recaptchaMixin, tooltipsMixin],

        events: {
            'tap .fn-next-btn': 'nextHandler',
            'tap .fn-submit': 'handleSubmit',
            'keyup input': 'handleKeyUp',
            'change': 'handleFormChange',
            'change select.fn-currency': 'handleCurrencyChange',
            'tap .fn-popup-open': 'onPopupOpen',
            'tap .fn-back-btn': 'backToPreviousStep'
        },

        initialize: function() {
            this.options = this.model.toJSON();
            this.currentStep = 0;
            this.childViews = [];
            this.storePromoCode();
            this.initRecaptcha({
                selector: '.fn-sign-up-recaptcha',
                operation: 'signup'
            });

            history.extendState({ stepNumber: 0, showBack: false }, 'step');
            core.trigger('backButton:show');
        },

        subscribe: function() {
            this.listenTo(core, 'registration:login', this.showLoginPopup);
            this.listenTo(core, 'recaptcha:show', this._hideLoading);
            this.listenTo(this.model, 'formData:update', this._onStepDataChange);
            this.listenTo(this.model, 'change:formData', this._onFormDataChange);
            this.listenTo(this.model, 'change:config', this.updateModelConfigListener);

            $(window).on('orientationchange.registration', function() {
                if (window.orientation === 0 || window.orientation === 180) {
                    this.scrollPageContent();
                }
            }.bind(this));

            this._onPopState = this.onPopState.bind(this);

            // NB Backbone.History handles `popstate` event and calls router's `defaultAction`, which renders page and
            // portlets on it. `subscribe` method is called during this process. After it ends, jBone starts to handle
            // this very `popstate`. So, if we use $() subscription, we'll handle event that was fired BEFORE
            // subscription was made (when navigating back via browser from some page).
            window.addEventListener('popstate', this._onPopState);

            window.addEventListener('click', this.closeTooltip.bind(this));

            this.subscribeOnRecaptcha();
        },

        render: function() {
            var fragment = document.createDocumentFragment();

            this.childViews.forEach(function(step) {
                fragment.appendChild(step.render().el);
            });

            this.$el.html(this.tmpl('registration', {
                layout: this.options.config.layoutStyle
            }));

            this.$('.fn-register-content').html(fragment);

            if (this.options.config.layoutStyle === 'registration-wizard') {
                this.showStep(0);
            } else {
                this.renderControls();
            }

            this.rendered = true;

            this._applyFormRules();

            return this;
        },

        portletDidMount: function() {
            this.insertPromoCode();
        },

        updateModelConfigListener: function() {
            this._applyFormRules();
        },

        _applyFormRules: function() {
            formRulesUtil.applyFormRules(this, this.options.config.genericRules);
        },

        renderTitle: function() {
            var $titleRegion = this.$el.parents('.fn-portlet-wrapper').find('.fn-portlet-title-region');
            var renderTitle = function(stepNumber) {
                $titleRegion.html(this.tmpl(
                    'registration.title', {
                        layout: this.options.config.layoutStyle,
                        title: this.options.title,
                        stepNumber: stepNumber,
                        stepsCount: this.childViews.length
                    })
                );
            }.bind(this);

            renderTitle(1);

            this.listenTo(this, 'step:show', function(stepIndexNumber) {
                renderTitle(stepIndexNumber + 1);
            });
        },

        renderControls: function(options) {
            if (this.options.config.hasCustomButtons) {
                return;
            }

            this.$('.fn-register-controls').html(this.tmpl('registration.controls', _.extend({}, options, {
                isWizardLayout: this.options.config.layoutStyle === 'registration-wizard'
            })));
        },

        showStep: function(stepNumber) {
            this.currentStep = stepNumber;

            var $stepToShow = this.$('.fn-register-step').eq(stepNumber);

            this.trigger('step:show', stepNumber);
            this.$('.fn-register-step').addClass('hidden');
            $stepToShow.removeClass('hidden');

            this.renderControls({
                showBack: Boolean(stepNumber),
                showNext: stepNumber < this.childViews.length - 1,
                showSubmit: stepNumber === this.childViews.length - 1
            });
            this.scrollPopupContent($stepToShow);
            this.scrollPageContent();
            this.$('.fn-register-content')[0].focus();

            // temporary fix for ios 10
            if (device.os === 'ios') {
                if (device.browserName === 'safari' && parseInt(device.osVersion) >= 13) {
                    setTimeout(function() {
                        window.scrollTo(0, 1);
                    }, 500);
                }

                this.hideKeyboard();
            }
        },

        scrollPopupContent: function($stepToShow) {
            const parentPopup = $stepToShow.parents('.popup-modal__inner-content');

            if (!parentPopup.length) {
                return;
            }

            parentPopup[0].scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },

        /**
         * Show login popup, if user is registered and set checkbox in admin panel
         */
        showLoginPopup: function() {
            if (this.options.config.duplicateEmailLookup) {
                core.trigger('app:message', {
                    ID: 'showLogin',
                    data: {
                        afterLoginUrl: config.get('rootPage') || '/',
                        closeAll: true,
                        data: {
                            description: this.translate('playtech.mobile.system.user.login.description.emailExist')
                        },
                        onLogin: function() {
                            core.navigate(config.get('rootPage') || '/');
                        }
                    }
                });
            }
        },

        addSteps: function(steps) {
            if (Array.isArray(steps)) {
                steps.forEach(function(step) {
                    step.config = _.extend({}, this.model.get('config'), step.options.config);
                }, this);
                this.childViews = this.childViews.concat(steps);
            } else {
                steps.config = this.model.get('config');
                this.childViews.push(steps);
            }
        },

        removeAllSteps: function() {
            this.childViews = [];
        },

        handleKeyUp: function(e) {
            var ENTER_BTN_CODE = 13;
            var isLastStep = this.currentStep === this.childViews.length - 1;
            var isWizardLayout = this.options.config.layoutStyle === 'registration-wizard';

            if (e.keyCode === ENTER_BTN_CODE) {
                document.activeElement.blur();
                !isLastStep && isWizardLayout ? this.nextHandler() : this.handleSubmit();
            }
        },

        nextHandler: function() {
            const error = this.handleRecaptchaError();
            const stepView = this.childViews[this.currentStep];
            const goNext = stepView && !stepView.isLoading;

            if (error || !goNext) {
                return;
            }

            this.showRegistrationErrors(null);

            return stepView
                .validate()
                .done(() => {
                    this.showStep(this.currentStep + 1);
                    // this.currentStep is already incremented in this.showStep()
                    history.pushState({ stepNumber: this.currentStep, showBack: this.currentStep > 0 }, 'step');
                    core.trigger('backButton:show');
                    core.trigger('registration:changeStep', 'NEXT', this.currentStep);
                });
        },

        handleSubmit: function() {
            const error = this.handleRecaptchaError();

            if (error || this.childViews[this.currentStep].isLoading || this.isLoading) {
                return;
            }

            this._showLoading();
            this.showRegistrationErrors(null);

            return $
                .when(this.childViews.map(step => step.validate()))
                .done(this.submit.bind(this))
                .fail((validationError) => {
                    this._hideLoading();

                    if (validationError.step && this.options.config.layoutStyle === 'registration-wizard') {
                        var stepIndex = this.childViews.findIndex((view) => view === validationError.step);

                        this.showStep(stepIndex);
                        core.trigger('registration:changeStep', 'EXACT', this.currentStep);
                    }

                    if (this.options.config.hasCustomButtons) {
                        this.showRegistrationErrors({
                            content: i18n.t('playtech.mobile.registration.error.validation'),
                            className: 'error'
                        });
                    }
                });
        },

        submit: function() {
            if (user.get('relogin')) {
                this.loginUser();

                return;
            }

            var regConfig = this.options.config;
            var tcVersion = this.model.get('tcVersion');
            var formData = {};

            this.childViews.forEach(function(step) {
                $.extend(formData, step.getData());
            }, this);

            const referee = Playtech.API.referrer.getRefereeData('refuser');

            if (referee) {
                _.extend(formData, {
                    custom19: referee
                });

                Playtech.API.referrer.unsetRefereeCookie('refuser');
            }

            _.extend(formData, Playtech.API.affiliate.getAffiliateData());

            if (regConfig.creferer) {
                formData.creferer = formData.creferer
                    ? formData.creferer + ';' + regConfig.creferer
                    : regConfig.creferer;
            }

            if (tcVersion) {
                formData.tcVersion = tcVersion;
            }

            formData.clientPlatform = regConfig.downloadClientRegistration
                ? 'download'
                : device.clientPlatform;

            // in case promise is not returned -- create one
            Promise.resolve(this.filterFormDataOnSend(formData))
                .then((data) => this.sendRegistrationData(data));
        },

        /**
         * Added to override in inherited views
         * @param formData
         * @returns {*}
         */
        filterFormDataOnSend: async function(formData) {
            const { dataMap } = await Playtech.API.auth.getBeforeRegistrationHandler({ dataMap: formData });

            return dataMap;
        },

        sendRegistrationData: function(data) {
            notifier.stop();

            core.trigger('registration:sendForm');

            user.save('formData', data)
                .done(this.successRegisterInitial.bind(this))
                .fail(this.errorRegister.bind(this))
                .always(function(messages) {
                    core.trigger('registration:sendForm:done');
                    this._handleSetDepositLimitsError(messages);
                }.bind(this));
        },

        _onStepDataChange: function() {
            var formData = {};

            this.childViews.forEach(function(step) {
                _.extend(formData, step.getValidationData());
            });

            this.model.set('formData', formData);
        },

        _onFormDataChange: function() {
            // Update custom data on all forms for advanced validation
            var formData = this.model.get('formData');

            this.childViews.forEach(function(step) {
                var formOptions = step.form.options;

                formOptions.data = formOptions.data || {};
                _.extend(formOptions.data, formData);
            });
        },

        handleFormChange: function() {
            if (!this.rendered) {
                return;
            }

            formRulesUtil.applyFormRules(this, this.options.config.genericRules);
        },

        handleCurrencyChange: function(event) {
            this.childViews.forEach((step) => {
                step.handleUpdateLimitsCurrency?.(event);
            });
        },

        successRegisterInitial: function() {
            return $.when(this.sendPlayerTags())
                .then(this.successRegister.bind(this))
                .fail(this.errorRegister.bind(this));
        },

        successRegister: function() {
            user.unset('promoCode');

            if (this.options.config.downloadClientRegistration) {
                return Playtech.API.htcmd.login({
                    username: user.get('userName'),
                    password: user.get('password')
                });
            }

            core.trigger('registration:success', {
                username: user.get('userName'),
                userId: user.get('userId'),
                playerCode: user.get('playerCode')
            });

            // use only after registration login
            core.once('auth:login', this.redirectAfterRegister.bind(this));

            notifier.start();

            this.loginUser();
        },

        sendPlayerTags: function() {
            var allTags = [];

            // reg builder tags
            if (this.options.config.regBuilderForm) {
                allTags = this.childViews
                    .reduce(function(memo, step) {
                        return memo.concat(step.getPlayerTags());
                    }, []);
            }

            // static portlet-wide tags
            if (this.options.config.enablePlayerTags) {
                allTags = allTags.concat(
                    this.options.config.tagsConfiguration
                        // do not overlap tags
                        .filter(function(tag) {
                            return allTags.every(function(existingTag) {
                                return existingTag.name !== tag.name;
                            });
                        })
                        .map(function(tag) {
                            let expirationDate = Number(tag.expirationDate);

                            if (expirationDate > 0) {
                                const date = new Date();

                                date.setDate(date.getDate() + expirationDate);
                                expirationDate = window.Playtech.API.formatter.date(date, '%Y-%m-%d');
                            } else {
                                expirationDate = '';
                            }

                            return {
                                ...tag,
                                expirationDate
                            };
                        })
                );
            }

            allTags = allTags.filter(Boolean);

            const rafCookie = Playtech.API.referrer.getRefereeData();

            Playtech.API.referrer.unsetRefereeCookie();

            if (rafCookie) {
                allTags = allTags.concat([
                    {
                        name: 'RAF/referred_by',
                        type: 'text',
                        expirationDate: '',
                        value: rafCookie
                    },
                    {
                        name: 'RAF/is_referred',
                        type: 'text',
                        expirationDate: '',
                        value: 'yes'
                    }
                ]);
            }

            allTags = _.uniq(allTags.reverse(), true, (tag) => tag.name).reverse();

            if (allTags.length > 0) {
                var request = {
                    ID: 35544,
                    responses: [35545, 35546],
                    description: 'Set player tags',
                    correlationId: _.uniqueId('setPlayerTags'),
                    tags: allTags
                };

                return serverUtil.sendBatchRequest(
                    [request], user.get('userId'));
            }
        },

        loginUser: function() {
            user.set('afterRegisterLogin', true);

            return user.fetch()
                .then(() => {
                    user.unset('afterRegisterLogin');
                })
                .fail((error) => {
                    this.errorRegister(error);
                });
        },

        redirectAfterRegister: function() {
            var action = this.model.get('config').afterRegistrationAction;

            core.once('page:rendered', function() {
                notifier.start();
            });

            core.navigate(action ? action : '/');
        },

        _showLoading: function() {
            this.isLoading = true;
            Form.toggleLoading(this.$('.fn-register-controls'), true);
        },

        _hideLoading: function() {
            this.isLoading = false;
            Form.toggleLoading(this.$('.fn-register-controls'), false);
        },

        _handleSetDepositLimitsError: function(messages) {
            var depositLimitError = _.findWhere(messages, { ID: 89900 });

            if (depositLimitError) {
                core.trigger('app:message', depositLimitError);
            }
        },

        errorRegister: function(error) {
            const { ID } = error;
            const errorCode = error.data?.errorCode;
            const onError = (message) => {
                core.trigger('registration:error', message);
                this.showRegistrationErrors(message);
                notifier.start();
            };

            // if CreatePlayerInfoErrorResponse and error 301, than enable reCaptcha flow
            if (errorCode === 301 && ID === 33006) {
                this.showSubmitRecaptcha({
                    onValidate: token => user.set('signUpVerificationToken', token),
                    onError: ({ translated: content, className = 'error' }) => onError({ content, className })
                });
            } else if (errorCode !== 0) {
                onError(this.getRegistrationErrorMessage(error));
            }

            this._hideLoading();
        },

        showRegistrationErrors: function(messages) {
            let html;

            if (!messages || messages.length === 0) {
                html = '';
            } else {
                html = Array.isArray(messages)
                    ? messages.map(function(msg) {
                        return this.tmpl('common.messages', msg);
                    }.bind(this)).join('')
                    : this.tmpl('common.messages', messages);
            }

            this.$('.fn-register-messages').html(html);

            if (html) {
                const $stepToShow = this.$('.fn-register-step').eq(this.currentStep);

                scrollManager.scrollTo(0);
                this.scrollPopupContent($stepToShow);
            }
        },

        handleRecaptchaError: function() {
            const recaptchaError = this.getRecaptchaError();

            if (recaptchaError) {
                this.showRegistrationErrors({
                    content: i18n.t(recaptchaError.translation),
                    className: 'error'
                });
            }

            return recaptchaError;
        },

        close: function() {
            PortletView.prototype.close.call(this);
            $(window).off('.registration');
            window.removeEventListener('popstate', this._onPopState);
            window.removeEventListener('click', this.closeTooltip);
        },

        onPopState: function() {
            if (history.state !== null && this.options.config.layoutStyle === 'registration-wizard') {
                const error = this.handleRecaptchaError();

                if (!error) {
                    this.showRegistrationErrors(null);
                    this.showStep(history.state.stepNumber || 0);
                    core.trigger('page:clear');
                    core.trigger('registration:changeStep', 'PREVIOUS', this.currentStep);
                } else {
                    history.pushState({ stepNumber: this.currentStep, showBack: this.currentStep > 0 }, 'step');
                }
            }
        },

        onPopupOpen: (e) => {
            e.preventDefault();
            const popupParams = e.target.dataset;

            if (Object.keys(popupParams).length > 0) {
                window.Playtech.API.popup.showPopup(popupParams);
            }
        },

        backToPreviousStep: () => {
            if (history.state.stepNumber > 0) {
                window.history.back();
            }
        }
    });
});
